import React from 'react';
import { translate } from '../../services';
import { leafIcon } from '../../../style/images';
import { Tooltip,Box } from '@mui/material';

const ProductEcoSolutionComp = ({ product }) => {

    return <> {product.ecoLink ? <Tooltip title={ translate( 'EcoSolutions' ) }><a href={product.ecoLink} target="_blank">
        <Box component="img" src={leafIcon}></Box>
    </a></Tooltip> : null} </>;
};


export const ProductEcoSolution = ProductEcoSolutionComp;
